
import React from 'react';
import Sidebar from './components/Sidebar';
import AgencyForm from './components/AgencyForm';

function App() {
  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <main className="flex-1 p-6 overflow-y-auto">
        <h1 className="text-2xl font-bold mb-4">Agency Management</h1>
        <AgencyForm />
      </main>
    </div>
  );
}

export default App;
